import React from "react";

const Main = (props) => {
  return <h1>This is the Main Component</h1>;
};

export default Main;